import { PaymentMethod } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

export const PaymentMethodServices = {
  getCardList: async () => {
    try {
      const payload = {
        ...PaymentMethod.getCardList,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  postSaveRemoveCard: async ({ body, queryParams }) => {
    try {
      const payload = {
        ...PaymentMethod.saveRemoveCard,
        bodyData: body,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getStripeKey: async () => {
    try {
      const payload = {
        ...PaymentMethod.paymentSetting,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  // deleteRemoveCard: async (bodyData) => {
  //     try {
  //         const payload = {
  //             ...PaymentMethod.removeCard,
  //             bodyData,
  //         };
  //         const res = await APIrequest(payload);
  //         return res;
  //     } catch (error) {
  //         logger(error);
  //         throw error;
  //     }
  // },
};
